import { render, staticRenderFns } from "./Reserves.vue?vue&type=template&id=627a5ef3&scoped=true&"
import script from "./Reserves.vue?vue&type=script&lang=ts&"
export * from "./Reserves.vue?vue&type=script&lang=ts&"
import style0 from "./Reserves.vue?vue&type=style&index=0&id=627a5ef3&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "627a5ef3",
  null
  
)

export default component.exports